import { Link } from "react-router-dom";
import { buildCatalogPath } from "../../../shared/utils/topbarUtils";

const CatalogNavigationGrid = ({ items = [], collection = "", currentLevel = "section", menuStructure = [] }) => (
  <div className="catalog-navigation-grid">
    {items.map((item) => (
      <Link
        key={`${currentLevel}-${item.id}-${item.name}`}
        to={buildCatalogPath({
          collection,
          subcollection: item.name,
          familyId: item.id,
          menuStructure,
        })}
        className="catalog-navigation-card"
      >
        <div className="catalog-navigation-card-body">
          <strong>{item.name}</strong>
          {Array.isArray(item.items) && item.items.length ? (
            <span className="catalog-navigation-card-meta">
              {item.items.length} subcategoria{item.items.length === 1 ? "" : "s"}
            </span>
          ) : (
            <span className="catalog-navigation-card-meta">Ver productos</span>
          )}
        </div>
        <i className="pi pi-angle-right" aria-hidden="true"></i>
      </Link>
    ))}
  </div>
);

export default CatalogNavigationGrid;
